module.exports = __webpack_public_path__ + "static/home_prep_photo-2cc6ff820753bee68c1f02221c089f89.jpg";